import axios from 'axios'
import { VITE_API_BASE_URL_STRAPI } from '../../assets/constants'

const strapiAxios = axios.create({
    baseURL: VITE_API_BASE_URL_STRAPI
})

strapiAxios.interceptors.request.use(
    (config) => {
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    (error) => {
        Promise.reject(error)
    }
)

strapiAxios.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        return Promise.reject(error)
    }
)

export default strapiAxios
